export default "__VITE_ASSET__17pX9aEj__"